/**
 * 배지 10종 · 반 공동 목표 3종(SR-ACH-02 · P2-S6 계약 §0) — 부여는 서버 권위(제어 평면 규칙 표), 셸은 그리기만 한다.
 * 아이콘은 서버가 주는 값이 먼저고, 없을 때 이 표로 대신한다. 이름은 문구 카탈로그(footprints.badge.<key>)에서만.
 * 개수·순위·남과의 비교는 그리지 않는다(DR-01) — 순서는 이 표 순서로 고정(받은 순서로 줄 세우지 않는다).
 */
export const BADGES = [
  ["first-upload", "📤"],
  ["version-up", "🔧"],
  ["first-finish", "🏁"],
  ["hill-climber", "⛰"],
  ["retry-grit", "💪"],
  ["gallery-visitor", "👀"],
  ["pushout-first", "🥊"],
  ["carry-together", "🤝"],
  ["sandbox-explorer", "🧪"],
  ["cheer", "👏"],
] as const;

export type BadgeKey = (typeof BADGES)[number][0];
export const BADGE_KEYS: readonly BadgeKey[] = BADGES.map(([k]) => k);
const ICONS = new Map<string, string>(BADGES);

/** 배지 아이콘(모르는 키는 🏅) */
export const badgeIcon = (key: string, server?: string | null) =>
  server && server.trim() ? server : (ICONS.get(key) ?? "🏅");

export const isBadgeKey = (k: unknown): k is BadgeKey => typeof k === "string" && ICONS.has(k);

/**
 * 반 공동 목표 — 와이어 sfs-10 순서('모두 완주하기' 먼저). 와이어의 '릴레이 완성'은 릴레이 모드가 없어 all-upload(모두 올리기)로 바꿨다.
 * P3-S2 — relay-done(릴레이 완성 · DEC-003 §7)을 4번째로 되살렸다. 서버가 보낼 때만(PH3 릴레이 플래그가 켜진 코스) 보인다.
 */
export const GOAL_KEYS = ["all-finish", "all-upload", "all-visit", "relay-done"] as const;
export type GoalKey = (typeof GOAL_KEYS)[number];
